import PaymentOptionsLoadingStatus from '../../../../enums/PaymentOptionsLoadingStatus';
import Track from '../../../utils/tracking';
import * as CheckoutAPIActions from '../../APIActions/CheckoutAPIActions';
import setPaymentOptionsLoadingStatus from '../setPaymentOptionsLoadingStatus';
import setOpttySessionData from './setOpttySessionData';

export default function getSessionDataForOptty() {
  return (dispatch) => {
    dispatch(setPaymentOptionsLoadingStatus(PaymentOptionsLoadingStatus.LOADING));
    return dispatch(CheckoutAPIActions.getSessionDataForOptty())
      .then((opttySessionResponse) => {
        if (opttySessionResponse.status === 200 && opttySessionResponse.msg) {
          dispatch(setOpttySessionData(opttySessionResponse.msg));
        } else {
          Track.error(`Error getting Optty session data from Checkout API: response: ${JSON.stringify(opttySessionResponse)}`);
          dispatch(setPaymentOptionsLoadingStatus(PaymentOptionsLoadingStatus.ERROR));
        }
      })
      .catch((e) => {
        Track.error(`Error setting Optty session data: ${e}`);
        dispatch(setPaymentOptionsLoadingStatus(PaymentOptionsLoadingStatus.ERROR));
      });
  };
}
